// extracted by mini-css-extract-plugin
export default {"checkbox-group":"DjGenresCheckBoxGroup_checkbox-group__-cu6Y","genres-grid":"DjGenresCheckBoxGroup_genres-grid__uNTDS"};